import DOMPurify from 'dompurify';

const EMAIL_TAGS = [
  'a',
  'abbr',
  'article',
  'aside',
  'b',
  'br',
  'blockquote',
  'body',
  'caption',
  'code',
  'col',
  'colgroup',
  'div',
  'dl',
  'dt',
  'dd',
  'em',
  'figure',
  'figcaption',
  'footer',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'head',
  'header',
  'hr',
  'html',
  'img',
  'li',
  'link',
  'main',
  'meta',
  'nav',
  'ol',
  'p',
  'picture',
  'section',
  'small',
  'span',
  'strong',
  'sub',
  'sup',
  'style',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'title',
  'tr',
  'u',
  'ul',
];

const SANITIZE_CONFIG = {
  ALLOWED_TAGS: EMAIL_TAGS,
  ADD_TAGS: ['mj-section', 'mj-column', 'mj-text'],
  ALLOWED_ATTR: [
    'style',
    'class',
    'id',
    'width',
    'height',
    'align',
    'valign',
    'role',
    'title',
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-hidden',
    'bgcolor',
    'color',
    'border',
    'cellpadding',
    'cellspacing',
    'href',
    'target',
    'name',
    'rel',
    'src',
    'alt',
    'colspan',
    'rowspan',
    'type',
    'summary',
    'background',
    'data-width',
    'data-height',
    'data-align',
  ],
  ADD_ATTR: [/^data-[\w-]+$/i],
  FORBID_TAGS: ['script', 'iframe', 'embed', 'object', 'base'],
  ALLOW_DATA_ATTR: true,
  ALLOW_ARIA_ATTR: true,
  KEEP_CONTENT: true,
};

const SCRIPTLET_REGEX = /<%[\s\S]*?%>/g;

const protectScriptlets = html => {
  const placeholders = [];
  const safeHtml = html.replace(SCRIPTLET_REGEX, match => {
    const token = `__REGMAIL_SCRIPTLET_${placeholders.length}__`;
    placeholders.push({ token, value: match });
    return token;
  });
  return { safeHtml, placeholders };
};

const restoreScriptlets = (html, placeholders) =>
  placeholders.reduce(
    (acc, { token, value }) => acc.split(token).join(value),
    html
  );

export const sanitizeEmailHtml = (html = '') => {
  const source = typeof html === 'string' ? html : '';
  if (!source) return '';

  const { safeHtml, placeholders } = protectScriptlets(source);
  const sanitized = DOMPurify.sanitize(safeHtml, SANITIZE_CONFIG);

  if (!placeholders.length) {
    return sanitized;
  }

  return restoreScriptlets(sanitized, placeholders);
};
